/**
 * Wraps an API function with standard success and error handlers.
 *
 * @param apiFunc The API function to wrap.
 * @returns
 */
import { isErrorBody } from '../errors/ErrorHandler';
import { GenericError } from '../errors/GenericError';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withStandardHandlers(apiFunc, translationKey, unwrapResults = true) {
    return async (...args) => {
        const res = await apiFunc(...args);
        if (!res.ok) {
            const body = (await res.json());
            if (body instanceof Object && isErrorBody(body)) {
                throw new GenericError(translationKey, body.status_id);
            }
            throw new GenericError(translationKey, res.status);
        }
        if (res.status === 204)
            return {}; // Return empty object for 204 No Content
        const result = await res.json();
        if (!(result instanceof Object)) {
            return result;
        }
        return (unwrapResults && 'results' in result ? result.results : result);
    };
}
